import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routing } from './sot.routing';
import { SOTLayoutComponent } from './layout/sotLayout/sotLayout.component';
import * as Components from './components';
import * as Services from './services';
import * as Directives from "./directives";
import * as Dialogs from "./dialogs";
import * as Pipes from "./pipes";
import { SOT_LANGUAGE_SERVICE_INJECTION_TOKEN, SOT_SERVICE_INJECTION_TOKEN } from './injectionToken';

import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { SwiperModule, SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { InternationalisationModule } from '../core/forked/angular-internationalisation';
import { InlineSVGModule } from "../core/forked/ng-inline-svg";
import { SharedModule } from '../shared.module';

// SwiperOptions from 'swiper' could also be used here instead of SwiperConfigInterface
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: 'horizontal',
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  centeredSlides: true
};

// Module
const imports: Array<Type<any> | ModuleWithProviders | any[]> = [
  SharedModule,
  CommonModule,
  InternationalisationModule,
  InlineSVGModule,
  routing,
  MatTabsModule,
  MatStepperModule,
  MatDialogModule,
  SwiperModule,
];

// Provider
const providers: Provider[] = [
  Services.SOTService,
  { provide: SOT_SERVICE_INJECTION_TOKEN, useExisting: Services.SOTService }, // to split from app.component.ts
  Services.SOTWebSocketService,
  Services.SOTLanguageService,
  { provide: SOT_LANGUAGE_SERVICE_INJECTION_TOKEN, useExisting: Services.SOTLanguageService }, // to avoid circular dependency warning
  Services.SOTStyleService,
  { provide: SWIPER_CONFIG, useValue: DEFAULT_SWIPER_CONFIG },
  Services.SOTDialogService,
];

// Deklarationen for modal dialog Component
const entryComponents: Array<Type<any> | any[]> = [
  Dialogs.CardlimitDialogComponent,
  Dialogs.CountdownDialogComponent,
  Dialogs.LoaderDialogComponent,
  Dialogs.SimpleMessageDialogComponent,
  Dialogs.SelectionDialogComponent,
  Dialogs.SingleProductDialogComponent,
  Dialogs.ProductRecommendationDialogComponent,
  Dialogs.TipDialogComponent,
  Dialogs.AgeDialogComponent,
  Dialogs.NumberPadDialogComponent,
  Dialogs.CouponNumberPadDialogComponent,
  Dialogs.ProductTagFilterDialogComponent,
  Dialogs.BonusActionsDialogComponent,
  Dialogs.VoucherScanDialogComponent,
  Dialogs.VoucherNumberPadDialogComponent,
  Dialogs.VoucherPinNumberPadDialogComponent,
  Dialogs.VoucherPayDialogComponent,
  Dialogs.ProductSubDialogComponent,
  Dialogs.AccessibilityDialogComponent,
];

// Deklarationen
const declarations: Array<Type<any> | any[]> = [
  SOTLayoutComponent,

  Directives.BackBtn,
  Directives.ProcessCardComponent,
  Directives.StepperComponent,
  Directives.LangCall,
  Directives.User,
  Directives.Amount,
  Directives.Properties,
  Directives.CountDown,
  Directives.NumberPad,
  Directives.SOTTruncatedTextDirective,

  Components.InitpageComponent,
  Components.UserProfil,
  Components.SplashscreenComponent,
  Components.ErrorpageComponent,
  Components.OrderTypeComponent,
  Components.MenuComponent,
  Components.ProductComponent,
  Components.RecipeLinkComponent,
  Components.RecommendationDishComponent,
  Components.ProductAdditionalInfo,
  Components.ProductDetailViewComponent,
  Components.CheckoutComponent,
  Components.CheckoutComponent,
  Components.CardscanComponent,
  Components.StartCardscanComponent,
  Components.PagerComponent,
  Components.PagerConfirmationComponent,
  Components.PaymentComponent,
  Components.PaymentConfirmationComponent,
  Components.CouponComponent,
  Components.OutofOrderComponent,
  Components.SOTScrollerVerticalComponent,
  Components.SOTPreLoadImages,


  ...entryComponents,

  Pipes.SOTPricePipe,
];

// Exports for AppModule
const mExports: Array<Type<any> | any[]> = [

];

// Modul
const ngModule: NgModule = {
  declarations: declarations,
  imports: imports,
  entryComponents: entryComponents,
  exports: mExports,
  providers: providers
};

@NgModule(ngModule)
export class SOTModule { }
